var _rect, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0196 10.91C16.7096 10.91 14.0196 13.6 14.0196 16.91V19.8C14.0196 20.41 13.7596 21.34 13.4496 21.86L12.2996 23.77C11.5896 24.95 12.0796 26.26 13.3796 26.7C17.6896 28.14 22.3396 28.14 26.6496 26.7C27.8596 26.3 28.3896 24.87 27.7296 23.77L26.5796 21.86C26.2796 21.34 26.0196 20.41 26.0196 19.8V16.91C26.0196 13.61 23.3196 10.91 20.0196 10.91Z",
    stroke: "#4B525A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8699 11.2C20.6606 10.8556 19.3792 10.8556 18.1699 11.2C18.4599 10.46 19.1799 9.94 20.0199 9.94C20.8599 9.94 21.5799 10.46 21.8699 11.2Z",
    stroke: "#4B525A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0195 27.06C23.0195 28.71 21.6695 30.06 20.0195 30.06C19.1995 30.06 18.4395 29.72 17.8995 29.18C17.3377 28.6173 17.0213 27.8552 17.0195 27.06",
    stroke: "#4B525A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.75,
    cy: 10,
    r: 5,
    fill: "#EF2020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ac01a18419ff8ccf51d299d7f0131ffc.svg";
export { ForwardRef as ReactComponent };